<template>
  <component
    :class="[$style.container, background && $style[background]]"
    :is="as"
  >
    <TextComponent :class="$style.title" type="heading3" :color="color" as="h2" v-if="title">
      {{ title }}
    </TextComponent>
    <Stack :direction="direction" :spacing="spacing" :style="stackStyle">
      <slot />
    </Stack>
  </component>
</template>

<script>
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import TextComponent from '@hackthe6ix/vue-ui/Text';

  export default {
  name: `Card`,
  components: {
    TextComponent,
    Stack,
  },
  props: {
    stackStyle: String,
    background: String,
    direction: String,
    spacing: String,
    title: String,
    color: String,
    as: {
      type: String,
      default: `div`,
    },
  },
};
</script>

<style src="./Card.module.scss" lang="scss" module />
